import * as React from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "../../base/StoreControl";
import {ControlBaseProps} from "../../base/ControlBase";
import {CSSProperties} from "react";


import Select from 'react-select';
import './style.css'
import {ValidatorBase} from "shared/utilities/validator/ValidatorBase";
import {PropertyValidator} from "shared/utilities/validator/PropertyValidator";
import {StoreBase} from "shared/core/Store/StoreBase";

import './SearchableSelect.css';



export class SearchableSelect<S extends StoreBase=null> extends StoreControl<SearchableSelectProps<S>, SearchableSelectState> {
    static defaultProps: Partial<SearchableSelectProps<any>> = {
        isMulti:false,
        disabled:false,
        placeholder:'Select...'
    };
    public combo;
    public styles;
    constructor(props: SearchableSelectProps<S>, context?: any) {
        super(props, context);
        this.state={
            IsValid:props.IsValid?props.IsValid:true,
            ErrorMessage:props.ErrorMessage?props.ErrorMessage:''
        };


        this.styles={
            menuPortal: styles => ({ ...styles, zIndex: 1000001 }),
            singleValue:styles=>({...styles,lineHeight:22}),
            control:styles=>({...styles,minHeight:33.5}),
            input:styles=>({...styles,margin:0,padding:0}),
            container:styles=>({...styles,margin:0,padding:0}),
            indicatorsContainer:styles=>({...styles,margin:0,padding:0,height:30}),
            valueContainer:styles=>({...styles,margin:0,padding:'0 12px'})

        };
    }




    public render() {
        let options:{value:string,label:string,item:any}[]=[];
        for(let option of React.Children.toArray(this.props.children))
        {

            options.push({
                value:(option as any).props.value,
                label:(option as any).props.children,
                item: typeof (option as any).props['data-item']!="undefined"?(option as any).props['data-item']:null
            })
        }

        return (

            <div className={'rncontrol '+(this.state.IsValid?'':'has-errors')} style={this.props.style}>
                <label style={{width: '100%'}}>{this.props.Label}</label>
                <Select classNamePrefix={'rnSelect'} placeholder={this.props.placeholder} isDisabled={this.props.disabled} styles={this.styles}  menuPortalTarget={document.body} menuPlacement={"auto"} menuPosition={'absolute'}className={'rnSelect'} isSearchable={true} options={options} isMulti={this.props.isMulti}
                                  defaultValue={this.GetSelectedOption(options)} value={this.GetSelectedOption(options)} onChange={(e: any) => {
                    this.props.isMulti?this.SetValue(e.map(x=>x.value),e) :this.SetValue(e.value, e.item)
                }}/>
                {this.GetValidationSection()}
            </div>

        )
    }

    private GetSelectedOption(options: { value: string; label: string }[]) {
        if(this.props.isMulti) {
            let values=this.GetArrayValue();
            return options.filter(x => values.indexOf(x.value)>=0);
        }
        else
            return options.filter(x=>x.value==this.GetStringValue());


    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return  this.GetNumericValue()>0},"Required field")
        ];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SearchableSelectProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    isMulti?:boolean;
    disabled?:boolean;
    placeholder?:string;

}

interface SearchableSelectState  extends StoreControlState{

}

//#endregion "My Region"

